export default __webpack_public_path__ + "static/media/back.29c441d2.svg";